import { Component, EventEmitter, Injector, Input, Output, ViewChild } from '@angular/core';
import { IItem } from '@app/modules/mazars-common/interfaces/item.interface';
import { AppComponentBase } from '@shared/common/app-component-base';
import { MazarsStatusChange } from './mazars-status-change';
import { MazarsStatusEditModalComponent } from './mazars-status-edit-modal.component';

@Component({
    selector: 'app-mazars-status',
    templateUrl: './mazars-status.component.html',
})
export class MazarsStatusComponent extends AppComponentBase {
    @ViewChild('mazarsStatusEditModal')
    mazarsStatusEditModal: MazarsStatusEditModalComponent;

    @Input('uid') uid: string;
    @Input('statusValue') statusValue: string;
    @Input('title') title: string;
    @Input('isEditable') isEditable = false;
    @Input('statusItems') statusItems: IItem<string>[] = [];

    @Output() onStatusChange: EventEmitter<MazarsStatusChange> = new EventEmitter<MazarsStatusChange>();

    constructor(
        injector: Injector
    ) {
        super(injector);
    }

    showStatusEditModal() {
        if (!this.isEditable) {
            return;
        }

        this.mazarsStatusEditModal.show(this.statusValue, this.statusItems).then((statusChange) => {
            this.onStatusChange.emit(<MazarsStatusChange>{
                value: statusChange.value,
                reason: statusChange.reason,
            });
        });
    }
}
